export default {"src":"/_next/static/media/cards-icon-5.35ff2eb4.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};